<app-card class="h-100 px-5 py-4">
    <div class="row mb-4">
      <div class="col-lg-9 my-auto">
        <span class="extrabold text-size-20px">Rendimiento mensual</span>
      </div>
      <div class="col-lg-3 my-auto">
        <select class="form-select select-gray">
          <option>Esta semana</option>
        </select>
      </div>
    </div>
    <img src="assets/svg/trend-chart.svg">
  </app-card>
  